import { render, staticRenderFns } from "./DisplayOrderItems.vue?vue&type=template&id=19344fc3&scoped=true"
import script from "./DisplayOrderItems.vue?vue&type=script&lang=js"
export * from "./DisplayOrderItems.vue?vue&type=script&lang=js"
import style0 from "./DisplayOrderItems.vue?vue&type=style&index=0&id=19344fc3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19344fc3",
  null
  
)

export default component.exports